import { storeCreator } from '@/utils/store/store.utils';
interface StateData {
  modalVisible: boolean;
  healthPlanName?: string;
}
interface State extends StateData {
  handleReset: () => void;
  handleSetState: (payload: Partial<StateData>) => void;
}

const DEFAULT_VALUES: StateData = {
  modalVisible: false,
  healthPlanName: undefined,
};

export const useStore = storeCreator<State>((set) => ({
  ...DEFAULT_VALUES,
  handleSetState: (value) => set((state) => ({
    ...state,
    ...value 
  })),


  handleReset: () => set((state) => ({
    ...state,
    ...DEFAULT_VALUES
  })),
}));